import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="bg-darkBackground flex flex-col justify-center items-center text-center" style={{ height: 'calc(100vh - 80px)' }}> {/* Subtracting the header height */}
      <header className="text-center mb-4"> 
        <h1 className="text-6xl font-extrabold text-cyberBlue mb-6 animate-pulse">
          Welcome to MavHack
        </h1>
        <p className="text-xl text-textWhite mb-4 max-w-2xl leading-relaxed">
          Challenge yourself and sharpen your skills in web exploitation, cryptography, binary exploitation, and more.
        </p>
        <p className="text-lg text-gray-400 max-w-2xl leading-relaxed">
          Learn, compete, and grow in a community-driven environment. Get started with interactive and fun challenges!
        </p>
      </header>

      <div className="p-6 rounded-lg shadow-lg max-w-lg w-full text-center">
        <div className="flex justify-center space-x-6 mb-6">
          {/* Link to Challenges */}
          <Link
            to="/challenges"
            className="bg-accentBlue text-white py-4 px-8 rounded-full text-lg font-semibold shadow-lg hover:bg-cyberBlue transition-all duration-300 transform hover:-translate-y-1 focus:outline-none"
          >
            View Challenges
          </Link>

          {/* Link to Leaderboard */}
          <Link
            to="/leaderboard"
            className="bg-gray-700 text-white py-4 px-8 rounded-full text-lg font-semibold shadow-lg hover:bg-gray-600 transition-all duration-300 transform hover:-translate-y-1 focus:outline-none"
          >
            View Leaderboard
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Home;
